export enum ADMIN_STATUSES {
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
}
